import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router';
import { getSSODetails, getSsoToken, resisterAndLogin } from '../services/privateapicalling';
import { useDispatch, useSelector } from 'react-redux';
import { OnSignIn, setUserDet } from '../../../core/data/redux/authSlice';
import { jwtDecode } from 'jwt-decode';
import{toast,ToastContainer} from 'react-toastify'
function TraderPanelLogin({handleFetchSsoDet}) {

  const { loginRole } = useParams();

  const [isLoginChecked , setIsLoginChecked] = useState(true);
  const [isSSODetailFetched , setIsSSODetailFetched] = useState(false);
  const token = useSelector((state: any) => state.auth.token);
  const language = useSelector((state:any)=>state.auth.language);
    const formLanguage = useSelector((state:any)=>state.auth.formLanguage);
  const isAuthenticated = !!token;
  const dispatch = useDispatch();
  const roleIdentifier = useSelector(
    (state: any) => state.auth.userDetails?.Role?.Role_Identifier
  );

     const location = useLocation();
    const params = new URLSearchParams(location.search);
    // const loginRole = params.get("role");
    const ssoid = params.get('SSOId');
    const navigate = useNavigate();

        const generateSsoToken = async()=>{
          try {
            const res = await getSsoToken()
            return res;
          } catch (error) {
          
          }
        }
      
        function base64DecodeProper(base64Str) {
        const binaryStr = atob(decodeURIComponent(base64Str));
        const bytes = Uint8Array.from(binaryStr, c => c.charCodeAt(0));
        const decoder = new TextDecoder("utf-8");
        return decoder.decode(bytes);
      }
      
        const fetchUserDetail = async ()=>{
          try {
            // dispatch(OnSignIn(""));

            const ssoGeneratedToken = await generateSsoToken();
            
      
            const base64String = ssoid; // "AjAyNTA1KjoiMDAwNDkwMLAwMPA%3P"
            // const correctBase64 = decodeURIComponent(base64String);
            const decodedSSOID =  base64DecodeProper(ssoid)
      
           
      
            const formData = new FormData();
            formData.append('UserName',decodedSSOID)
      
            const ssores = await getSSODetails(formData , ssoGeneratedToken.data );
    
           
            if(ssores.type=="success" && ssores.isError==false)
            {
              
              const role = loginRole == "Trader" ? "Trader" : loginRole == "Panel_Engineer" ? "Panel Engineer" : loginRole == "General_Commission_Agent" ? "General Commission Agent" : ""
              const decodeAndLogin = await resisterAndLogin(ssores.result , role);
              setIsLoginChecked(true);        
              
              if(decodeAndLogin.success)
              {
                  dispatch(OnSignIn(decodeAndLogin.Body));
                
                  const decodedToken = jwtDecode(decodeAndLogin.Body);
                    
                
                      dispatch(setUserDet(decodedToken));
                        let currTime = new Date().getTime();
                      currTime = currTime + 36000000;
                      // currTime = currTime + 20000;
                      localStorage.setItem("tokenExpTime", currTime.toString());
                    //   setIsSSODetailFetched(true);
                    handleFetchSsoDet();
                    //   const route = loginRole=="Trader" ? "/my-applications" : "/myApplicationPanel" 
                    //   navigate(route)
    
              }
              else
              toast.error(decodeAndLogin.message)
              
            }
            else{
              toast.error('ssoId not valid')
              setIsLoginChecked(true);        
    
            }
          } catch (error) {
     
              setIsLoginChecked(true);        

          }
        }
      
        useEffect(()=>{
       
          if(ssoid)
          {
          setIsLoginChecked(false);        
        
          fetchUserDetail();
      
          }
        },[ssoid])


   if (!isLoginChecked) {
   return (
      <div id="global-loader">
        <div className="page-loader"></div>
      </div>
    );
}

 return (
  <>
    <div className="flex justify-center items-center h-screen">
      You are not authorised user or This request already been used or expired
    </div>
    <ToastContainer autoClose={3000} position='top-right'/>
    </>
  );
}

export default TraderPanelLogin
